<template>
  <div class="container">
    <h1 class="display-4">Thank you for entering the 2019 CAP Prize!</h1>
    <p>We'll get get back to you once the judges have had a chance to review your work.</p>

    <b-card-group columns>
      <entry-add-card v-if="open"/>
      <entry-card
        v-for="entry in closedEntries"
        :key="entry.eid"
        :entry="entry"
        :photos="entry.photos"
        :open="open"
      />
    </b-card-group>

    <b-modal
      @hidden="hidden"
      id="modalUser"
      title="Your information"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div class="d-block">
        <update-user/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import EntryCard from '@/components/EntryCard.vue'
import EntryAddCard from '@/components/EntryAddCard.vue'
import UpdateUser from '@/components/user/UpdateUser.vue'
export default {
  name: 'list-entries',
  props: ['uid'],
  components: { EntryCard, EntryAddCard, UpdateUser },
  computed: {
    ...mapGetters({
      entryCount: 'entry/entryCount'
    }),
    ...mapState({
      entries: state => state.entry.entries,
      user: state => state.user.user,
      open: state => state.open
    }),
    closedEntries: function() {
      let closedEntriesArray = this.entries.filter(
        entry => entry.complete == true
      )
      return closedEntriesArray
    }
  },
  methods: {
    hidden() {
      // console.log('In the hidden function:' + this.entry.eid)
    }
  },
  mounted() {
    this.$store.dispatch('entry/fetchEntries', this.uid)
  }
}
</script>

<style scoped>
h1 {
  margin-top: 1em;
}
</style>
